"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDDMMYYYY = exports.formatHHmmss = exports.formatDM = exports.formatHmm = exports.formatD = exports.formatYYYY = exports.formatDMYYYY = exports.formatYYYYMM = exports.formatHHmm = exports.formatYYYYMMDD = void 0;
// Fast, hardcoded replacements for the most-used moment `.format(...)` patterns.
//
// `.format()` runs moment's token parser + locale machinery on every call, which is expensive
// in hot render paths (the calendar builds thousands of these per pass). These read the moment's
// numeric getters directly and build the string by hand - never calling `.format()`. For a valid
// moment the output is identical to `.format()`; these tokens (YYYY / MM / DD / HH / mm / ss and
// their non-padded variants) are locale-independent, so cs/en produce the same digits.
const pad2 = (n) => (n < 10 ? `0${n}` : `${n}`);
const pad4 = (n) => n < 10 ? `000${n}` : n < 100 ? `00${n}` : n < 1000 ? `0${n}` : `${n}`;
/** 'YYYY-MM-DD' — e.g. 2026-07-23 */
const formatYYYYMMDD = (m) => `${pad4(m.year())}-${pad2(m.month() + 1)}-${pad2(m.date())}`;
exports.formatYYYYMMDD = formatYYYYMMDD;
/** 'HH:mm' — e.g. 09:05 */
const formatHHmm = (m) => `${pad2(m.hours())}:${pad2(m.minutes())}`;
exports.formatHHmm = formatHHmm;
/** 'YYYY-MM' — e.g. 2026-07 */
const formatYYYYMM = (m) => `${pad4(m.year())}-${pad2(m.month() + 1)}`;
exports.formatYYYYMM = formatYYYYMM;
/** 'D.M.YYYY' — e.g. 3.7.2026 */
const formatDMYYYY = (m) => `${m.date()}.${m.month() + 1}.${pad4(m.year())}`;
exports.formatDMYYYY = formatDMYYYY;
/** 'YYYY' — e.g. 2026 */
const formatYYYY = (m) => pad4(m.year());
exports.formatYYYY = formatYYYY;
/** 'D' — day of month, no leading zero — e.g. 3 */
const formatD = (m) => `${m.date()}`;
exports.formatD = formatD;
/** 'H:mm' — e.g. 9:05 */
const formatHmm = (m) => `${m.hours()}:${pad2(m.minutes())}`;
exports.formatHmm = formatHmm;
/** 'D.M.' — e.g. 3.7. */
const formatDM = (m) => `${m.date()}.${m.month() + 1}.`;
exports.formatDM = formatDM;
/** 'HH:mm:ss' — e.g. 09:05:00 */
const formatHHmmss = (m) => `${pad2(m.hours())}:${pad2(m.minutes())}:${pad2(m.seconds())}`;
exports.formatHHmmss = formatHHmmss;
/** 'DD.MM.YYYY' — e.g. 03.07.2026 */
const formatDDMMYYYY = (m) => `${pad2(m.date())}.${pad2(m.month() + 1)}.${pad4(m.year())}`;
exports.formatDDMMYYYY = formatDDMMYYYY;
